/* import __COLOCATED_TEMPLATE__ from './escalation-learn-button.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

export default class EscalationLearnButtonComponent extends Component {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get learnArticles() {
    return [
      {
        items: [
          {
            text: this.intl.t('ai-agent.guidance.escalation.how-to-use-article'),
            icon: 'article',
            onSelectItem: () => {
              window.Intercom(
                'showArticle',
                this.appService.app.canUseStandalone ? 12399729 : 12396892,
              );
            },
          },
          {
            text: this.intl.t('ai-agent.guidance.escalation.best-practices-article'),
            icon: 'article',
            onSelectItem: () => {
              window.Intercom('showArticle', 10560969);
            },
          },
        ],
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Guidance::EscalationLearnButton': typeof EscalationLearnButtonComponent;
    'ai-agent/guidance/escalation-learn-button': typeof EscalationLearnButtonComponent;
  }
}
